import Box from '@/common/components/Box'
import { ChartRenderer } from '@/common/components/ChartRenderer'
import { ChartData } from '@/common/types/chart.type'
import { cn } from '@/common/utils/cn'
import { ChartLegend } from '@/features/dashboard/components/chartLegend'

interface ChartSectionProps {
  chartData: ChartData
}

export const ChartSection = ({ chartData }: ChartSectionProps) => {
  const legend =
    Object.keys(chartData.series_settings).length > 1 &&
    Object.values(chartData.series_settings).some(({ label }) => label)
      ? Object.keys(chartData.series_settings).map((key) => ({
          label: chartData.series_settings[key].label,
          color: chartData.series_settings[key].color,
        }))
      : []

  return (
    <Box
      className={cn('w-full bg-white-200 rounded-lg p-0 overflow-hidden')}
      style={{ gridColumn: `span ${chartData.width}` }}
    >
      <div className="flex flex-col w-full gap-2 bg-white-200 p-4 pt-6">
        <div className="flex flex-col gap-1">
          <p className="font-bold text-2xl">{chartData.title}</p>
          {chartData.subtitle && <p className="font-light text-[10px] leading-3">{chartData.subtitle}</p>}
        </div>

        {!!legend?.length && <ChartLegend legend={legend} />}
      </div>

      <ChartRenderer chartData={chartData} className="p-6 pb-12 max-h-80 [&_.recharts-rectangle.recharts-tooltip-cursor]:fill-transparent" />
    </Box>
  )
}
